define('home/views/HomepageRecommendedFeedEmptyView',[
    'core/strings',

    'home/views/HomepageFeedEmptyView',
], function (
    strings,

    HomepageFeedEmptyView
) {
    'use strict';

    var gettext = strings.get;

    var HomepageRecommendedFeedEmptyView = HomepageFeedEmptyView.extend({
        feedMessage: gettext('Follow channels and people to see their recommended discussions here.'),
        noChannelEmptyViewTexts: {
            mainText: 'See recent discussions by following communities.',
            subText: 'Following communities helps you keep up with what their latest discussions.',
            followText: 'Find interesting communities to follow »',
            followButtonUrl: 'https://help.disqus.com/community-tips/building-identity-and-audience/site-profiles',
            emptyImage: 'following-communities.png',
        },
    });

    return HomepageRecommendedFeedEmptyView;
});

